import { MAP_LAYERS, type MapLayer } from '../../hooks/useMapLayer';

export default function LayerControl({
  currentLayer,
  onLayerChange,
  dark = false,
}: {
  currentLayer: MapLayer;
  onLayerChange: (layer: MapLayer) => void;
  dark?: boolean;
}) {
  return (
    <div
      className={`rounded-xl p-2 flex gap-1 ${
        dark ? 'bg-ink-900/85 backdrop-blur border border-ink-700 shadow-2xl' : 'bg-white shadow-warm'
      }`}
    >
      {(Object.keys(MAP_LAYERS) as MapLayer[]).map((layer) => (
        <button
          key={layer}
          onClick={() => onLayerChange(layer)}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
            currentLayer === layer
              ? dark
                ? 'bg-ember text-ink-950'
                : 'bg-tutela-forest text-white shadow-sm'
              : dark
                ? 'text-mist-muted hover:bg-ink-800 hover:text-mist'
                : 'text-tutela-slate hover:bg-tutela-forest/5 hover:text-tutela-forest'
          }`}
        >
          {MAP_LAYERS[layer].name}
        </button>
      ))}
    </div>
  );
}
